import React, { useEffect, useRef } from "react";
import "./Template.css";

import TemplateFilter from "./TemplateFilter";
import TemplateTable from "./TemplateTable";
import TemplatePagination from "./TemplatePagination";

export default function Template({
  data = [],
  unit,
  category,
  setCategory,
  search,
  setSearch,
  searchType,
  setSearchType,
  handleSearch,
  page,
  setPage,
}) {
  const itemsPerPage = 10;

  const totalItems = data.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const handleSearchRef = useRef(handleSearch);
  const isFirstRender = useRef(true);

  useEffect(() => {
    handleSearchRef.current = handleSearch;
  }, [handleSearch]);

  useEffect(() => {
    if (totalPages > 0 && page > totalPages) {
      setPage(totalPages);
    }
  }, [page, totalPages, setPage]);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
    } else {
      setPage(1);
    }

    const timer = setTimeout(() => {
      if (typeof handleSearchRef.current === "function") {
        handleSearchRef.current();
      }
    }, 300);

    return () => clearTimeout(timer);
  }, [search, searchType, category, setPage]);

  const safePage =
    totalPages === 0
      ? 1
      : Math.min(Math.max(page, 1), totalPages);

  const startIndex = (safePage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  const pagedData = data.slice(startIndex, endIndex);

  return (
    <div className="cc-unit-template">
      <div className="cc-unit-template-inner">
        <div className="cc-unit-template-header">
          학생자치 규정과 각종 회의록, 학생자치에 필요한 양식 등을
          확인하실 수 있습니다.
        </div>

        <TemplateFilter
          category={category}
          setCategory={setCategory}
          search={search}
          setSearch={setSearch}
          searchType={searchType}
          setSearchType={setSearchType}
          handleSearch={handleSearch}
        />

        <div className="cc-unit-template-layout">
          <div className="cc-unit-template-content">
            <TemplateTable
              data={pagedData}
              unit={unit}
              page={safePage}
              itemsPerPage={itemsPerPage}
              total={totalItems}
            />
          </div>

          {totalPages > 1 && (
            <TemplatePagination
              page={safePage}
              setPage={setPage}
              total={totalItems}
              itemsPerPage={itemsPerPage}
            />
          )}
        </div>
      </div>
    </div>
  );
}